import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, exhaustMap } from 'rxjs/operators';
import { CategoryService } from '@services/category.service';
import * as AdminCategoriesActions from './admin-categories.actions';

@Injectable()
export class AdminCategoriesEffects {
  private readonly actions$ = inject(Actions);
  private readonly categoryService = inject(CategoryService);

  loadAdminCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminCategoriesActions.loadAdminCategories),
      exhaustMap(action =>
        this.categoryService.getCategoryList(action.page, action.size, action.name).pipe(
          map(response => AdminCategoriesActions.loadAdminCategoriesSuccess({ response })),
          catchError(error => of(AdminCategoriesActions.loadAdminCategoriesFailure({ error })))
        )
      )
    )
  );
}
